import {
	GET_PROJECT_BUDGET,
	GET_PROJECT_BUDGET_DELETE,
	UPDATE_PRODUCT_DISCOUNT_BUDGET,
	CREATE_BUDGET,
	CREATE_BUDGET_USA,
	UPDATE_PRODUCT_QTY_BUDGET,
	CALCULATE_TOTALS_BUDGET,
	UPDATE_DISCOUNT_BUDGET_FOOTER,
	UPDATE_SURCHARGE_BUDGET_FOOTER,
	UPDATE_IVA_BUDGET_FOOTER,
	UPDATE_COMMENT_BUDGET,
	CLEAR_GENERATE_BUDGET,
	GET_PREVIOUS_BUDGETS,
	CHECK_PREVIOUS_BUDGET_ITEM
} from '@/redux/actions/budget.actions'
import { LOGOUT } from '@/redux/actions/auth.actions'

const initialState = {
	loading: false,
	error: false,
	createBudget: null,
	details: {},
	previousBudgets: {
		list: [],
		projectId: null,
		countChecked: 0
	}
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case GET_PROJECT_BUDGET.REQUEST:
		case GET_PROJECT_BUDGET.SUCCESS:
		case GET_PROJECT_BUDGET.FAILURE:
		case GET_PREVIOUS_BUDGETS.FAILURE:
		case GET_PREVIOUS_BUDGETS.REQUEST:
			return false
		case GET_PREVIOUS_BUDGETS.SUCCESS:
			return true
		default:
			return state
	}
}

const error = (state = initialState.error, action) => {
	switch (action.type) {
		case GET_PROJECT_BUDGET.FAILURE:
			return true
		case GET_PROJECT_BUDGET.REQUEST:
		case GET_PROJECT_BUDGET.SUCCESS:
		case CREATE_BUDGET.REQUEST:
		case CREATE_BUDGET.SUCCESS:
		case CREATE_BUDGET_USA.REQUEST:
		case CREATE_BUDGET_USA.SUCCESS:
			return false
		default:
			return state
	}
}

const details = (state = initialState.details, action) => {
	switch (action.type) {
		case GET_PROJECT_BUDGET.SUCCESS: {
			const subTotal = action.payload.products?.reduce((acc, product) => {
				if (product.isPersonalized && !product.isDiscontinued) {
					const pvpUnitR = product.quantity * product.prices.unitGross
					const discountR = pvpUnitR * ((product.discount || 0) / 100)
					const priceNetoR = pvpUnitR - discountR
					return parseFloat((acc + priceNetoR).toFixed(2))
				}
				return acc
			}, 0)

			return {
				...action.payload,
				products: action.payload.products?.reduce(
					(acc, product) => {
						!acc && (acc = { orderedIds: [], byId: {}, byType: {} })
						if (product.isPersonalized && !product.isDiscontinued) {
							return {
								orderedIds: [...acc.orderedIds, product._id],
								byId: { ...acc.byId, [product._id]: { ...product, discount: null } },
								byType: {
									...acc.byType,
									[product.type]: acc.byType[product.type] ? [...acc.byType[product.type], product._id] : [product._id]
								}
							}
						} else {
							return { ...acc }
						}
					},
					{ orderedIds: [], byId: {}, byType: {} }
				),
				subTotal,
				netTotal: subTotal
			}
		}
		case GET_PROJECT_BUDGET_DELETE.SUCCESS:
			return {
				...state,
				products: state.products.orderedIds
					?.filter((_id) => _id !== action.payload)
					.reduce(
						(acc, productId) => {
							const product = state.products.byId[productId]
							if (product._id !== action.payload)
								return {
									orderedIds: [...acc.orderedIds, product._id],
									byId: { ...acc.byId, [product._id]: product },
									byType: {
										...acc.byType,
										[product.type]: acc.byType[product.type]
											? [...acc.byType[product.type], product._id]
											: [product._id]
									}
								}
						},
						{ orderedIds: [], byId: {}, byType: {} }
					)
			}
		case UPDATE_PRODUCT_QTY_BUDGET.SUCCESS: {
			return {
				...state,
				products: {
					orderedIds: state.products.orderedIds,
					byId: {
						...state.products.byId,
						[action.payload.productId]: {
							...state.products.byId[action.payload.productId],
							quantity: action.payload.quantity
						}
					}
				}
			}
		}
		case CALCULATE_TOTALS_BUDGET.SUCCESS: {
			const subTotal = state.products?.orderedIds.reduce((acc, productId) => {
				const product = state.products.byId[productId]
				const pvpUnitR = product.quantity * product.prices.unitGross
				const discountR = pvpUnitR * ((product.discount || 0) / 100)
				const priceNetoR = pvpUnitR - discountR
				return parseFloat((acc + priceNetoR).toFixed(2))
			}, 0)
			const discountValue = parseFloat(((subTotal || 0) * (state.discount / 100)).toFixed(2)) || 0
			const surchargeValue = parseFloat(((subTotal - discountValue) * (state.surcharge / 100)).toFixed(2)) || 0
			const ivaValue = parseFloat(((subTotal - discountValue + surchargeValue) * (state.iva / 100)).toFixed(2)) || 0
			const netTotal = (subTotal - (discountValue || 0) + (surchargeValue || 0) + (ivaValue || 0)).toFixed(2)

			return {
				...state,
				products: {
					...state.products
				},
				subTotal,
				discountValue,
				surchargeValue,
				ivaValue,
				netTotal
			}
		}
		case UPDATE_PRODUCT_DISCOUNT_BUDGET.SUCCESS: {
			return {
				...state,
				products: {
					orderedIds: state.products.orderedIds,
					byId: {
						...state.products.byId,
						[action.payload.productId]: {
							...state.products.byId[action.payload.productId],
							discount: action.payload.discount
						}
					}
				}
			}
		}
		case UPDATE_DISCOUNT_BUDGET_FOOTER.SUCCESS: {
			return {
				...state,
				discount: action.payload.discount
			}
		}
		case UPDATE_SURCHARGE_BUDGET_FOOTER.SUCCESS: {
			return {
				...state,
				surcharge: action.payload.surcharge
			}
		}
		case UPDATE_IVA_BUDGET_FOOTER.SUCCESS: {
			return {
				...state,
				iva: action.payload.iva
			}
		}
		case UPDATE_COMMENT_BUDGET.SUCCESS: {
			return {
				...state,
				comment: action.payload.comment
			}
		}
		case CLEAR_GENERATE_BUDGET:
			return {}
		case LOGOUT.SUCCESS:
		case LOGOUT.FAILURE:
			return []
		case GET_PROJECT_BUDGET.REQUEST:
		case GET_PROJECT_BUDGET.FAILURE:
		default:
			return state
	}
}

const previousBudgets = (state = initialState.previousBudgets, action) => {
	switch (action.type) {
		case GET_PREVIOUS_BUDGETS.SUCCESS: {
			return {
				...action.payload,
				list: action.payload.list.reduce((acc, budget) => {
					acc.push({ ...budget, isChecked: false })
					return acc
				}, []),
				countChecked: 0
			}
		}
		case CHECK_PREVIOUS_BUDGET_ITEM.SUCCESS: {
			return {
				...state,
				list: state.list.map((budget) => {
					budget.id === action.payload.id && (budget.isChecked = action.payload.isChecked)
					return budget
				}),
				countChecked: action.payload.isChecked ? ++state.countChecked : --state.countChecked
			}
		}
		case LOGOUT.SUCCESS:
		case LOGOUT.FAILURE:
			return []
		case GET_PREVIOUS_BUDGETS.REQUEST:
		case GET_PREVIOUS_BUDGETS.FAILURE:
		default:
			return state
	}
}

const createBudget = (state = initialState.createBudget, action) => {
	switch (action.type) {
		case CREATE_BUDGET.REQUEST:
		case CREATE_BUDGET_USA.REQUEST:
		case CLEAR_GENERATE_BUDGET:
			return null
		case CREATE_BUDGET.SUCCESS:
		case CREATE_BUDGET.FAILURE:
		case CREATE_BUDGET_USA.SUCCESS:
		case CREATE_BUDGET_USA.FAILURE:
			return action.payload
		default:
			return state
	}
}

export default {
	name: 'budget',
	reducers: {
		loading,
		error,
		details,
		createBudget,
		previousBudgets
	}
}
